import React, {
  ChangeEvent,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { AppContext } from "./App";
import { FiSettings } from "react-icons/fi";
import { MdClose } from "react-icons/md";

export default function SettingsMenu() {
  const {
    hasStarted,
    highGraphics,
    setHighGraphics,
    masterVolumeRef,
    playerSpeed,
  } = useContext(AppContext);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [screenState, setScreenState] = useState(0);
  const [showHint, setShowHint] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hintTime = 3500;

  useEffect(() => {
    function giveHint() {
      if (playerSpeed.current.x === 0 && playerSpeed.current.z === 0) {
        setShowHint(true);
        timerRef.current = setTimeout(hideHint, 100);
      }
    }

    function hideHint() {
      if (playerSpeed.current.x !== 0 || playerSpeed.current.z !== 0) {
        setShowHint(false);
      } else {
        timerRef.current = setTimeout(hideHint, 100);
      }
    }

    if (hasStarted) timerRef.current = setTimeout(giveHint, hintTime);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [hasStarted]);

  function updateVolume(e: any) {
    masterVolumeRef.current = e.target.value;
  }

  return (
    hasStarted && (
      <>
        <div
          className={`absolute select-none top-4 right-4 p-1 ${
            settingsOpen ? "w-[260px] h-[140px]" : "w-8 h-8"
          } border-[2px] border-white rounded-md cursor-pointer transition-all max-w-[calc(100vw-32px)] bg-black`}
          onClick={() => {
            if (!settingsOpen) {
              setSettingsOpen(true);
            }
          }}
        >
          {!settingsOpen && (
            <FiSettings
              className="absolute top-1 right-1"
              size="20px"
              color="white"
            />
          )}
          {settingsOpen && (
            <>
              <MdClose
                className="absolute top-1 right-1 cursor-pointer"
                size="25px"
                color="white"
                onClick={() => setSettingsOpen(false)}
              />
              <div className="text-white font-cardo leading-relaxed text-xl w-full p-4 mt-4 fadeIn">
                <div className="flex items-center mb-2">
                  <div>Volume:</div>
                  <input
                    className="ml-4"
                    type="range"
                    min={0}
                    max={1}
                    step={0.1}
                    onChange={updateVolume}
                  />
                </div>
                <div className="flex items-center">
                  <div>Graphics:</div>
                  <GraphicsButton
                    selected={!highGraphics}
                    onClick={() => setHighGraphics(false)}
                  >
                    Low
                  </GraphicsButton>
                  <GraphicsButton
                    selected={highGraphics}
                    onClick={() => setHighGraphics(true)}
                  >
                    High
                  </GraphicsButton>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="absolute select-none bottom-4 left-4 text-white font-cardo tracking-wide flex items-start flex-col">
          <b className="text-lg sm:text-3xl block">Manifold</b>
          <div className="text-md sm:text-2xl -mt-1">By Ruben Gerards</div>
          <a
            target="_blank"
            href="https://www.rubengerards.com"
            className="block italic underline cursor-pointer sm:mt-1 text-md sm:text-xl"
          >
            Return to rubengerards.com
          </a>
        </div>
        <div
          className={`absolute select-none top-1/2 left-1/2 -translate-x-1/2 w-full text-center -translate-y-1/2 text-white font-cardo tracking-wide pointer-events-none transition-opacity duration-1000 ${
            showHint ? "opacity-100" : "opacity-0"
          }`}
        >
          <b className="text-md sm:text-xl block max-w-[66vw] w-full m-auto p-2 mt-20">
            Use the arrow keys or touch the screen to move
          </b>
        </div>
      </>
    )
  );
}

function GraphicsButton({ selected, children, onClick }: any) {
  return (
    <div
      className={`p-1 ml-2 border-[1px] cursor-pointer rounded-md ${
        selected ? "border-opacity-100" : "border-opacity-0"
      } transition-all border-white `}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
